import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { SingleLineEllipsis } from 'components/styles';

export const HoverableLinkButton = styled(Button).attrs((props) => ({
  size: props.size || 'small',
  type: 'link',
  hideHoverEffect: true,
  hideHoverBorderRadius: true,
}))`
  max-width: 152px;
  &:hover {
    color: var(--white-100);
    background: var(--primary-color);
  }
  > svg {
    flex-shrink: 0;
  }
  > span {
    width: 100%;
    ${SingleLineEllipsis};
  }
`;

export const TaskFilterButton = styled(HoverableLinkButton)`
  border-color: var(--primary-color);
`;

export const ButtonWrapper = styled.div`
  display: flex;

  ${HoverableLinkButton} {
    border-color: var(--primary-color);
  }
  > ${HoverableLinkButton}:first-child {
    border-right-width: 0px;
  }
`;
